<template>
  <div class="credits-wrapper">
    <div class="credits-container">
      <h1 class="credits-title">About Squishiverse</h1>

      <section class="credits-section">
        <p class="credits-body">
          Squishiverse is a complete NFT ecosystem featuring a custom marketplace,
          ERC-20 token integration, and gamified lootbox mechanics.
        </p>
      </section>

      <section class="credits-section">
        <h2 class="credits-subtitle">Development</h2>
        <p class="credits-body">
          Built in partnership with
          <a
            href="https://allthingsweb3.com/case-studies/squishiverse"
            target="_blank"
            rel="noopener"
            class="credits-link"
          >AllThingsWeb3</a>.
        </p>
      </section>

      <section class="credits-section">
        <h2 class="credits-subtitle">Marketing</h2>
        <p class="credits-body">
          Brand growth and marketing powered by
          <a
            href="https://www.itk.digital/"
            target="_blank"
            rel="noopener"
            class="credits-link"
          >itk.digital</a>, the core marketing arm behind the Squishiverse brand.
        </p>
      </section>

      <section class="credits-section metrics">
        <h2 class="credits-subtitle">Key Metrics</h2>
        <div class="metrics-grid">
          <div class="metric-card">
            <span class="metric-value">$3,000,000+</span>
            <span class="metric-label">Revenue</span>
          </div>
          <div class="metric-card">
            <span class="metric-value">$2,200</span>
            <span class="metric-label">Peak Floor Price</span>
          </div>
          <div class="metric-card">
            <span class="metric-value">24+</span>
            <span class="metric-label">Months Active</span>
          </div>
          <div class="metric-card">
            <span class="metric-value">Ongoing</span>
            <span class="metric-label">Community Engagement</span>
          </div>
        </div>
      </section>

      <section class="credits-section">
        <a
          href="https://allthingsweb3.com/case-studies/squishiverse"
          target="_blank"
          rel="noopener"
          class="credits-cta"
        >
          View Full Case Study
        </a>
      </section>

      <router-link to="/" class="credits-back">← Back to Home</router-link>
    </div>
  </div>
</template>

<script>
import { pages } from "../../vue.config";

export default {
  name: "CreditsView",
  metaInfo: {
    title: pages.credits.title,
    meta: [{ name: "description", content: pages.credits.metaDescription }],
  },
};
</script>

<style lang="scss" scoped>
.credits-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, $navy 0%, darken($navy, 5%) 50%, $black 100%);
  padding: 4rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.credits-container {
  max-width: 800px;
  width: 100%;
  text-align: center;
}

.credits-title {
  font-family: $font-primary;
  font-size: $font-lg;
  color: $pink;
  margin-bottom: 2rem;
  text-shadow: 0 4px 20px rgba($pink, 0.3);
}

.credits-subtitle {
  font-family: $font-primary;
  font-size: $font-sm;
  color: $blue;
  margin-bottom: 1rem;
}

.credits-section {
  margin-bottom: 2.5rem;

  &.metrics {
    margin-top: 3rem;
  }
}

.credits-body {
  font-family: $font-secondary;
  font-size: $font-xs;
  color: $white;
  line-height: 1.8;
  max-width: 600px;
  margin: 0 auto;
}

.credits-link {
  color: $green;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;

  &:hover {
    color: $green-hot;
    text-decoration: underline;
  }
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-top: 1.5rem;

  @media screen and (min-width: $screen-sm) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.metric-card {
  background: rgba($white, 0.05);
  border: 1px solid rgba($white, 0.1);
  border-radius: $radius-md;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba($pink, 0.3);
  }
}

.metric-value {
  font-family: $font-primary;
  font-size: $font-sm;
  color: $gold;
  font-weight: 700;

  @media screen and (min-width: $screen-sm) {
    font-size: $font-md;
  }
}

.metric-label {
  font-family: $font-secondary;
  font-size: $font-xxxs;
  color: $grey;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.credits-cta {
  display: inline-block;
  background: linear-gradient(135deg, $pink 0%, $pink-alt 100%);
  color: $white;
  font-family: $font-primary;
  font-size: $font-xxs;
  padding: 1rem 2rem;
  border-radius: $radius-md;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba($pink, 0.4);
  }
}

.credits-back {
  display: inline-block;
  margin-top: 2rem;
  font-family: $font-secondary;
  font-size: $font-xxs;
  color: $grey;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: $white;
  }
}
</style>

